import { render } from "./WDesviacionPresupuestal.vue?vue&type=template&id=54e11601&scoped=true"
import script from "./WDesviacionPresupuestal.vue?vue&type=script&lang=js"
export * from "./WDesviacionPresupuestal.vue?vue&type=script&lang=js"

import "./WDesviacionPresupuestal.vue?vue&type=style&index=0&id=54e11601&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e11601"]])

export default __exports__